export default __webpack_public_path__ + "static/media/Number_3_dark.ef023eaa.svg";